import React, { createContext, useState } from 'react';

import { ActiveDatepicker } from 'component/Search/Datepicker/types';
import { ActiveDurationLayer } from 'component/Search/Duration/types';

interface ToggleFormElementContextInterface {
    activeDatepicker: ActiveDatepicker;
    activeDurationLayer: ActiveDurationLayer;
    setActiveDatepicker: (activeDatepicker: ActiveDatepicker) => void;
    setActiveDurationLayer: (activeDurationLayer: ActiveDurationLayer) => void;
}

export const ToggleFormElementContext =
    createContext<ToggleFormElementContextInterface>({
        activeDatepicker: ActiveDatepicker.None,
        activeDurationLayer: ActiveDurationLayer.None,
        setActiveDatepicker: () => {},
        setActiveDurationLayer: () => {},
    });

export const ToggleFormElementProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [activeDatepicker, setActiveDatepicker] = useState(
        ActiveDatepicker.None
    );
    const [activeDurationLayer, setActiveDurationLayer] = useState(
        ActiveDurationLayer.None
    );

    return (
        <ToggleFormElementContext.Provider
            value={{
                activeDatepicker,
                activeDurationLayer,
                setActiveDatepicker,
                setActiveDurationLayer,
            }}
        >
            {children}
        </ToggleFormElementContext.Provider>
    );
};
